import { monolithMoment } from "../../utils/date-format";

const TraceAttributeDefs = [
  {
    dataField: "label",
    caption: "Type",
  },
  {
    dataField: "value",
    caption: "Value",
  },
  {
    dataField: "category",
    caption: "Category",
  },
  {
    dataField: "description",
    caption: "Description",
    visible: false,
  },
  {
    dataField: "created_by",
    caption: "Created By",
    render: (data) => data?.created_by?.full_name,
  },
  {
    dataField: "created_on",
    caption: "Created On",
    render: (data) =>
      monolithMoment({
        timestamp: data.created_on,
        includeTime: true,
        includeZone: true,
      }),
  },
  {
    dataField: "updated_on",
    caption: "Updated On",
    visible: false,
    render: (data) =>
      monolithMoment({
        timestamp: data.updated_on,
        includeTime: true,
        includeZone: true,
      }),
  },
];

export default TraceAttributeDefs;
